// Module
var code = "\r\n<div class=\"page page_main  dn\" id=\"monitor-page\" style=\"padding: 0px;\">  </div> ";
// Exports
export default code;